/**
 * Rotulos de profissional das telas publicas.
 *
 * `getProviderInitials` estava copiado identico em ProviderSelector e
 * ProviderTimeSlotsGrid. Ficaria uma terceira copia com a vitrine do perfil, e
 * copia de rotulo foi o que gerou nomes divergentes de categoria nesta serie.
 */

/** Iniciais para quando nao ha foto: no maximo duas, "PR" sem nome. */
export function getProviderInitials(name: string): string {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);
  if (parts.length === 0) return "PR";
  return parts.map((part) => part.charAt(0).toUpperCase()).join("");
}

export function resolveProviderSpecialization(description?: string | null): string {
  return String(description || "").trim() || "Profissional especialista";
}

export interface ProviderRating {
  average: number;
  reviewsCount: number;
  label: string;
}

/**
 * Avaliacao apresentavel do profissional: exige nota **e** avaliacao contada,
 * para nao anunciar media de zero resenha. Devolve null quando nao ha.
 */
export function resolveProviderRating(
  averageRating?: number | null,
  reviewsCount?: number | null
): ProviderRating | null {
  const count = Number(reviewsCount || 0);
  if (typeof averageRating !== "number" || !Number.isFinite(averageRating)) return null;
  if (count <= 0) return null;

  const average = Math.min(5, Math.max(1, averageRating));
  const formatted = average.toLocaleString("pt-BR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  return { average, reviewsCount: count, label: `${formatted} (${count})` };
}
